import React from 'react';
import PropTypes from 'prop-types';
import { Header, Body } from 'simplifyworks-core-ui';

/**
* Template represents base template for whole application.
*/
export default class Template extends React.Component {
	render() {
		return (
			<div>
				<Header title={this.props.title} />
				<Body main={this.props.main} />
			</div>
		);
	}
}

Template.propTypes = {
	// Page title
	title: PropTypes.node.isRequired,
	// Main content
	main: PropTypes.node.isRequired
};
